import { InitialPaginatedState, PaginatedState } from '@store/models';
import { DEFAULT_QUERY_PARAMS } from '@wlcm/angular/core';
import { Location } from '@core/models/entities/location.models';

export interface LocationsState extends PaginatedState<Location> {
  location: Location | null;
}

export const createInitialState = (): InitialPaginatedState<LocationsState> => {
  return {
    isLoaded: false,
    isFetching: false,
    isProcessing: false,
    isFetchingPaginated: false,
    paginatedData: null,
    queryParams: { ...DEFAULT_QUERY_PARAMS },
    location: null,
  };
};
